import React from "react"
import { Badge } from "reactstrap"
import PropTypes from "prop-types"
import { t } from "i18next"

function StatusBadge(props) {
  const { label, ...otherProps } = props

  const status_color = {
    pending: "warning",
    draft: "dark",
    extracted: "success",
    processed: "primary",
    inprogress: "primary",
    failed: "danger",
    true: "success",
    false: "danger",
  }

  return (
    <Badge
      className="text-capitalize"
      color={status_color[label]}
      {...otherProps}
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  children: PropTypes.node,
  label: PropTypes.any,
}

export default StatusBadge
